module.exports = __webpack_public_path__ + "img/market.b4236a73.png";